import { CheckCircle2, ShieldCheck } from "lucide-react";
import { formatEuro } from "./helpers";
import { StepHeader } from "./ProgressBar";

function PackItem({ children }) {
  return (
    <li className="flex items-start gap-2">
      <CheckCircle2 className="w-4 h-4 text-oc-fair mt-0.5 shrink-0" />
      <span>{children}</span>
    </li>
  );
}

export default function StepPakket({ bundle, setBundle, singlePriceCents, bundlePriceCents, baseAmountCents }) {
  return (
    <div className="max-w-3xl mx-auto space-y-8 animate-[fade-in-up_500ms_ease-out_both]">
      <StepHeader sub="Wil je meerdere offertes vergelijken? Kies dan voor het 3-pack en bespaar tot 33%.">
        Eén analyse of een 3-pack?
      </StepHeader>

      <div className="grid sm:grid-cols-2 gap-4" data-testid="bundle-step">
        <button
          type="button"
          onClick={() => setBundle(false)}
          data-testid="pakket-single"
          className={`relative text-left p-7 rounded-oc border-2 bg-white transition-all hover:-translate-y-0.5 hover:shadow-oc-card-hover ${
            !bundle ? "border-oc-primary shadow-oc-card-hover" : "border-oc-border"
          }`}
        >
          {!bundle && (
            <span className="absolute top-4 right-4 w-6 h-6 rounded-full bg-oc-primary text-white flex items-center justify-center">
              <CheckCircle2 className="w-4 h-4" />
            </span>
          )}
          <p className="text-[12px] uppercase tracking-[0.08em] font-semibold text-oc-textSecondary">Eén analyse</p>
          <p className="font-mono font-semibold text-[40px] text-oc-primary mt-2 leading-none">
            €{formatEuro(singlePriceCents)}
          </p>
          <p className="text-[13px] text-oc-textSecondary mt-1">Eenmalig — incl. 21% BTW</p>
          <ul className="mt-5 space-y-2 text-[14px] text-oc-textPrimary">
            <PackItem>Volledig rapport met heatmap</PackItem>
            <PackItem>PDF-download + e-mail</PackItem>
            <PackItem>30 dagen toegang</PackItem>
          </ul>
        </button>

        <button
          type="button"
          onClick={() => setBundle(true)}
          data-testid="pakket-bundle"
          className={`relative text-left p-7 rounded-oc border-2 bg-white transition-all hover:-translate-y-0.5 hover:shadow-oc-card-hover ${
            bundle ? "border-oc-secondary shadow-oc-card-hover" : "border-oc-border"
          }`}
        >
          <span className="absolute -top-3 left-7 bg-oc-secondary text-white text-[11px] uppercase tracking-[0.08em] font-bold px-3 py-1 rounded-full">
            Populair · -33%
          </span>
          {bundle && (
            <span className="absolute top-4 right-4 w-6 h-6 rounded-full bg-oc-secondary text-white flex items-center justify-center">
              <CheckCircle2 className="w-4 h-4" />
            </span>
          )}
          <p className="text-[12px] uppercase tracking-[0.08em] font-semibold text-oc-textSecondary">3-pack bundle</p>
          <p className="font-mono font-semibold text-[40px] text-oc-primary mt-2 leading-none">
            €{formatEuro(bundlePriceCents)}
          </p>
          <p className="text-[13px] text-oc-textSecondary mt-1">
            3 analyses · incl. 21% BTW · gem.{" "}
            <strong className="text-oc-fair">€{formatEuro(Math.round(bundlePriceCents / 3))}</strong> per stuk
          </p>
          <ul className="mt-5 space-y-2 text-[14px] text-oc-textPrimary">
            <PackItem>Alles uit het standaard pakket</PackItem>
            <PackItem>3 credits — 12 maanden geldig</PackItem>
            <PackItem>Ideaal om offertes te vergelijken</PackItem>
          </ul>
        </button>
      </div>

      <div
        className={`rounded-oc border p-5 transition-colors ${
          bundle ? "bg-oc-subtle border-oc-secondary/30" : "bg-oc-subtle border-oc-border"
        }`}
      >
        <div className="flex items-start gap-3 text-[14px] text-oc-textPrimary">
          <ShieldCheck className="w-5 h-5 text-oc-secondary shrink-0 mt-0.5" />
          <span>
            {bundle ? (
              <>
                Met het 3-pack krijg je <strong>3 credits</strong> op je e-mailadres. Eén wordt direct gebruikt voor deze offerte, de andere 2 blijven{" "}
                <strong>12 maanden geldig</strong>. Inwisselen via <em className="font-mono">/credits</em>.
              </>
            ) : (
              <>
                Geen abonnement, geen verrassingen. Je betaalt enkel voor deze ene offerte. Wil je later vergelijken? Je kan dan altijd nog een 3-pack kopen.
              </>
            )}
          </span>
        </div>
      </div>

      <div className="bg-white rounded-oc border border-oc-border p-5 flex items-center justify-between">
        <span className="text-[13px] uppercase tracking-[0.05em] font-semibold text-oc-textSecondary">Te betalen</span>
        <span className="text-right">
          <span className="font-mono font-semibold text-oc-primary text-[22px] block">
            € {formatEuro(baseAmountCents)}
          </span>
          <span className="text-[11px] text-oc-textSecondary">incl. 21% BTW</span>
        </span>
      </div>
    </div>
  );
}
